/**
 * API Rzzro — https://rzzro.com/api
 * Commodities en USD/mt (tonelada métrica). Requiere User-Agent.
 * Licencia CC BY 4.0 — atribución requerida.
 *
 * Nota: la API pública actual solo expone metales base LME
 * (cobre, aluminio, zinc, níquel, plomo, estaño). No incluye titanio.
 */
const RZZRO_API_BASE = "https://rzzro.com/api";
const USER_AGENT = "FacetJoyeria-EstadoOro/1.0";

/**
 * @param {{ commodity?: string, currency?: string }} [options]
 * @returns {Promise<{ commodities: Object, last_updated?: string, base?: string, unit?: string }>}
 */
export const fetchRzzroPrices = async (options = {}) => {
  const params = new URLSearchParams();
  if (options.commodity) params.set("commodity", options.commodity);
  if (options.currency) params.set("currency", options.currency);

  const qs = params.toString();
  const url = `${RZZRO_API_BASE}/prices.json${qs ? `?${qs}` : ""}`;

  const response = await fetch(url, {
    headers: { "User-Agent": USER_AGENT },
  });

  if (!response.ok) {
    throw new Error(`API Rzzro: HTTP ${response.status}`);
  }

  return response.json();
};

/**
 * Busca un commodity por clave (p. ej. "titanium", "copper").
 * @param {string} commodityKey
 * @returns {Promise<{ price: number, unit: string, exchange?: string }|null>}
 */
export const fetchRzzroCommodity = async (commodityKey) => {
  const data = await fetchRzzroPrices({ commodity: commodityKey });
  const entry = data?.commodities?.[commodityKey];
  if (!entry?.price) return null;

  return {
    price: entry.price,
    unit: data.unit || "USD/mt",
    exchange: entry.exchange,
    changePct: entry.change_pct,
    lastUpdated: data.last_updated,
  };
};
